import React from 'react';
import { useSelector } from 'react-redux';
import { MapView } from '../../components/locationsLayout/mapView';
import { PagePreview } from '../../components/locationsLayout/pagePreview';
import './index.scss';

export const LocationMapper = ({ locationKey, area }) => {
  const { floorStatics } = useSelector((state) => state.config);

  if (!locationKey || !area) return null;

  const mapperSelector = (map) => {
    return {
      ...floorStatics[map].paths.find((group) => group.location === area),
    };
  };

  const layoutPropsGenerator = (locationKey, area) => {
    const pagePropertiesObj = mapperSelector(locationKey);

    if (area === 'floorMap') {
      return {
        map: floorStatics[locationKey].img_map,
        section: floorStatics[locationKey].section,
        floor: floorStatics[locationKey].floor,
        title: pagePropertiesObj.title,
      };
    }

    return {
      map: floorStatics[locationKey].img_map,
      section: floorStatics[locationKey].section,
      floor: floorStatics[locationKey].floor,
      title: pagePropertiesObj.title,
      info: pagePropertiesObj.info,
      picture: pagePropertiesObj.img_banner,
      path: pagePropertiesObj.path,
      description: pagePropertiesObj.description,
    };
  };

  const pageProperties = layoutPropsGenerator(locationKey, area);
  return (
    <>
      {area !== 'floorMap' ? (
        <PagePreview pageProps={pageProperties} />
      ) : (
        <MapView mapProps={pageProperties} />
      )}
    </>
  );
};
